var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative questioner-answer",class:{'green-stripe': _vm.first},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"questionare-text bold"},[_vm._v(_vm._s(_vm.inner))])])
}
var staticRenderFns = []

export { render, staticRenderFns }